/**
 * @desc uniApi模块
 */
import { uniApiAxios } from '../httpInstance';
// 从简版报告获取车辆图片
export function getCarImgesData(payload) {
    return uniApiAxios({
        method: 'GET',
        url: 'getCarImgesData',
        params: Object.assign({ reportVersion: 'shdv001' }, payload),
    });
}
export function getFieldConfigList(params) {
    return uniApiAxios({
        method: 'GET',
        url: 'getFieldConfigList',
        params,
    });
}
export function saveFieldConfigList(data) {
    return uniApiAxios({
        method: 'POST',
        url: 'saveFieldConfigList',
        data: JSON.stringify(data),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
    });
}
